<template lang="pug">
.invoice-lookup
	table.invoice-lookup__table
		thead
			tr
				th(v-for="col in config.columns", scope="col", :style="col.width ? `width: ${col.width}px` : ''" :class="col.align ? 'override-align' : ''") {{ col.title }}
		tbody
			tr
				template(v-for="col in config.columns")
					td(v-if="col.inputRow" :data-label="col.title")
						input.invoice-lookup__input(v-if="col.type !== 'actions'", v-model="selected[col.var]", @focus="localError = ''")
						button.btn.invoice-lookup__search(v-else, @click="search()")
							label(v-if="!searchingInvoice") Find Invoice
							div.lds-ring(v-else)
								div
								div
								div
								div
					td(v-else)
			tr(v-for="(row, i) in invoices")
				template(v-for="col in config.columns")
					td(v-if="col.type !== 'actions'", :data-label="col.title", :class="col.align ? 'override-align' : ''") {{ displayValue(row, col) }}
					td(v-else)
						button.invoice-lookup__remove(@click="removeRow(i)")
	.invoice-lookup__message(v-if="errorMessage !== 'genericError'") <p v-html="errorMessage">{{errorMessage }}</p>
	.invoice-lookup__message-generic(v-else)
		span Something went wrong. Contact us for
		a(href="https://www.lexitaslegal.com/contact") Help
	.invoice-lookup__footer
		h5 Total Amount Due: {{ totalDue }}
		div(v-if="invoices.length > 0")
			a.btn.btn--secondary(@click="proceedToPayment") Proceed to Payment

</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "InvoiceLookup",
  components: {},
  data: function() {
    return {
      windowWidth: null,
      searchingInvoice: false,
      localError: "",
      selected: {
        invoiceNumber: "",
        orderNumber: ""
      }
    };
  },
  computed: {
    ...mapGetters(["config", "loading", "invoices", "invoiceError"]),
    errorMessage() {
      if (this.localError.length > 0) {
        return this.localError;
      } else {
        return this.invoiceError;
      }
    },
    totalDue() {
      let val = 0;
      this.invoices.forEach(el => {
        val += el.balance;
      });
      let dollarVal = val.toFixed(2);
      return `$${dollarVal}`;
    }
  },
  methods: {
    ...mapActions(["fetchInvoice"]),
    search() {
      if (this.searchingInvoice) return;
      this.localError = "";
      let _existing = this.invoices.find(
        el =>
          el.invoiceNumber === this.selected.invoiceNumber.trim() &&
          el.orderNumber === this.selected.orderNumber.trim()
      );
      if (this.selected["invoiceNumber"] === "" || _existing !== undefined) {
        if (_existing !== undefined) {
          this.localError = "Invoice already added!";
        }
      } else {
        this.searchingInvoice = true;
        this.fetchInvoice({
          payload: `${this.$root.api}/Invoice/FetchInvoice`,
          data: JSON.parse(JSON.stringify(this.selected))
        }).then(() => {
          Object.keys(this.selected).forEach(key => {
            this.selected[key] = "";
          });
          this.searchingInvoice = false;
        });
      }
    },
    proceedToPayment() {
      if (this.invoices.length === 0) return;
      this.localError = "";
      this.$emit("proceedToPayment");
    },
    removeRow(index) {
      this.invoices.splice(index, 1);
    },
    displayValue(row, col) {
      let val = row[col.key];
      if (col.type === "currency") {
        return `$${val}`;
      } else {
        return val;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.invoice-lookup {
  &__table {
    border: 1px solid $lightGray;
    border-collapse: collapse;
    margin: 0;
    padding: 0;
    width: 100%;
    table-layout: fixed;
    thead {
      tr {
        background-color: $orange;
        color: $white;
      }
    }
    tr {
      background-color: $neutralGray;
      border: 1px solid $lightGray;
      padding: 0.35em 0;
    }
    th,
    td {
      position: relative;
      padding: 0.625em 11px;
      text-align: right;
      &.override-align {
        text-align: left;
        text-indent: 5px;
      }
    }
    th {
      font-size: 0.85em;
      letter-spacing: 0.1em;
      text-transform: uppercase;
    }
  }
  &__input {
    height: 37px;
    width: 100%;
  }
  &__search,
  &__remove {
    cursor: pointer;
    border: 0;
  }
  &__search {
    padding: 0.5rem 1rem;
    position: absolute;
    right: 1rem;
    top: 0.625em;
    cursor: pointer;
    width: 160px;
    text-wrap: nowrap;
    label {
      cursor: pointer;
      display: flex;
      //&::after {
      //	@include icon;
      //	margin-left: .5rem;
      //	content: "\e902";
      //	font-weight: bold;
      //}
    }
  }
  &__remove {
    background: none;
    color: red;
    &::before {
      @include icon;
      content: "\e90e";
      font-weight: bold;
    }
  }
  &__message {
    margin-top: 0.5rem;
    text-align: right;
    color: red;
  }
  &__footer {
    padding-top: 2rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    h5 {
      margin: auto 0;
    }
  }

  @media screen and (max-width: 1100px) {
    &__table {
      border: 0;
      thead {
        border: none;
        clip: rect(0 0 0 0);
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        width: 1px;
      }
      tr {
        border-bottom: 3px solid $lightGray;
        display: block;
        margin-bottom: 0.625em;
      }

      td {
        display: none;
        &:before {
          content: attr(data-label);
          float: left;
          font-weight: bold;
          text-transform: uppercase;
        }
        &:last-child {
          border-bottom: 0;
        }
        &[data-label] {
          border-bottom: 1px solid $lightGray;
          display: block;
          font-size: 0.8em;
          text-align: right;
        }
      }
    }
    &__input {
      width: unset;
      height: unset;
    }
    &__search {
      position: unset;
      width: 100%;
    }
  }
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 85px;
  height: 1rem;
  padding: 0 32px;
  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 1rem;
    height: 1rem;
    border: 2px solid $white;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: $white transparent transparent transparent;
    &:nth-child(1) {
      animation-delay: -0.45s;
    }
    &:nth-child(2) {
      animation-delay: -0.3s;
    }
    &:nth-child(3) {
      animation-delay: -0.15s;
    }
  }
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
